import { render, staticRenderFns } from "./arrow-right.vue?vue&type=template&id=c0af08e6&"
import script from "./arrow-right.vue?vue&type=script&lang=js&"
export * from "./arrow-right.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports